import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        course: '=',
        drl: '=',
        hashKey: '=',
        form: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.Edit target' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <form-row error="vm.errors.templateTargets">
                    <span ng-bind-html="vm.errors.templateTargets"></span>
                </form-row>
                <div class="form">
                    <form-row error="vm.errors.departmentId">
                        <label class="label">{{ 'courses.Department' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.department" theme="selectize" title="{{ 'user.Choose department' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a department in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="department in vm.departments | filter: $select.search">
                                    <span ng-bind-html="department.name | highlight: $select.search" class="{{department.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row error="vm.errors.roleId">
                        <label class="label">{{ 'courses.Role' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.role" theme="selectize" title="{{ 'user.Choose role' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a role in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="role in vm.roles | filter: $select.search">
                                    <span ng-bind-html="role.name | highlight: $select.search" class="{{role.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row error="vm.errors.levelId">
                        <label class="label">{{ 'courses.Level' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.level" theme="selectize" title="{{ 'user.Choose level' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a level in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="level in vm.levels | filter: $select.search">
                                    <span ng-bind-html="level.name | highlight: $select.search" class="{{level.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Edit' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $q, lodash, FormFactory, TokenService, CourseService, ModalService, UserResource, CourseResource,
                 COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM, COURSE_TARGET_NEED_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_STATUS_ENUM,
                 AUTOMATED_PLANNING_GROUP_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM, toastr, $scope,
                 TasklistTemplateResource, ResponseService) {
        this.FormFactory = FormFactory;
        this.$translate = $translate;
        this.$q = $q;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.TokenService = TokenService;
        this.CourseService = CourseService;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TYPE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM;
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.CourseResource = CourseResource;
        this.ResponseService = ResponseService;
        this.toastr = toastr;
        this.$scope = $scope;
        this.TasklistTemplateResource = TasklistTemplateResource;
    }

    $onInit () {
        this.errors = [];
        this.departments = this.mapClassifier(this.departments, this.$translate.instant('course.All departments'));
        this.roles = this.mapClassifier(this.roles, this.$translate.instant('course.All roles'));
        this.levels = this.mapClassifier(this.levels, this.$translate.instant('course.All levels'));
        this.initDrl();
    }

    mapClassifier (classifier, defaultName) {
        classifier = classifier.map((val) => ({ name: val.value, id: val.id }));
        classifier.unshift({
            name: defaultName,
            id: undefined,
            class: 'separated'
        });
        return classifier;
    }

    initDrl () {
        this.department = { id: undefined, name: this.$translate.instant('course.All departments') };
        this.role = { id: undefined, name: this.$translate.instant('course.All roles') };
        this.level = { id: undefined, name: this.$translate.instant('course.All levels') };

        // find correct object from array to display on form
        this.existingDrl = this.drl;

        this.department = { id: this.existingDrl.departmentId, name: this.existingDrl.departmentName ? this.existingDrl.departmentName : this.$translate.instant('course.All departments') };
        this.role = { id: this.existingDrl.roleId, name: this.existingDrl.roleName ? this.existingDrl.roleName : this.$translate.instant('course.All roles') };
        this.level = { id: this.existingDrl.levelId, name: this.existingDrl.levelName ? this.existingDrl.levelName : this.$translate.instant('course.All levels') };
        this.previous = this.existingDrl;
    }

    beforeSave () {
        this.previous = this.drl;
        this.previousWithValue = this.drl;
        this.form.model.templateTargets = this.form.model.templateTargetsWithValue;

        this.$scope.$parent.vm.removeTargetByKey(this.drl.$$hashKey);
        this.form.model.templateTargets.push({
            id: this.drl.id,
            $$hashKey: this.drl.$$hashKey,
            departmentId: this.department.id,
            departmentName: this.department.name,
            roleId: this.role.id,
            roleName: this.role.name,
            levelId: this.level.id,
            leveltName: this.level.name,
            type: this.form.model.type
        });
    }

    revertChange () {
        this.$scope.$parent.vm.removeTargetByKey(this.drl.$$hashKey);
        this.form.model.templateTargetsWithValue.push(this.previousWithValue);
    }

    save () {
        delete this.form.errors.templateTargets;
        this.beforeSave();
        this.$scope.$parent.vm.save()
        .then((response) => {
            this.errors = [];
            this.form.model = response.data;
            this.uibModalInstance.close();
        })
        // in case of error remove the last added drl
        .catch(() => {
            this.uibModalInstance.close();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/tasklist/drl/edit/index.js